export function initScrollToTop(selector = '.arrow-top') {
    const btn = document.querySelector<HTMLAnchorElement>(selector);
    if (!btn) return;

    // Показ/скрытие кнопки при скролле
    const toggleVisibility = () => {
        if (window.scrollY > 500) {
            btn.classList.add('visible');
        } else {
            btn.classList.remove('visible');
        }
    };

    window.addEventListener('scroll', toggleVisibility);
    toggleVisibility(); // вызвать сразу, если уже проскролено

    // Прокрутка вверх при клике
    btn.addEventListener('click', (e) => {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
}
